const colors = [
    '#1f81cc', // Blue
    '#1fa1d9', //
    '#38cada', // Light Blue
    '#b6edec', // Cake Blue
    '#0a6882' // Dark Cake Blue
];

export default colors;